import { css } from '@/styled-system/css';

export const barStyles = css.raw({
  gridRow: 1,
  borderWidth: '4px',
  borderStyle: 'solid',
  borderRadius: '10px',
});

export const iconContainerStyles = css.raw({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '50%',
  marginTop: '50',
  border: '8px solid rgba(7, 77, 255, 0.1)',
  position: 'absolute',
  height: '900',
  width: '900',
  top: '{spacing.-400}',
  marginLeft: '45%',
});

export const iconBackgroundStyles = css.raw({
  borderRadius: '50%',
  border: '6px solid {colors.border.onHero.neutral}',
  borderStyle: 'solid',
  // oxlint-disable-next-line constellation/no-raw-spacing-values -- `height: 27px` falls between `600` (24px) and `700` (28px) on the numeric sizes scale
  height: '27px',
  // oxlint-disable-next-line constellation/no-raw-spacing-values -- `width: 27px` falls between `600` (24px) and `700` (28px) on the numeric sizes scale
  width: '27px',
  color: 'text.onHero.neutral',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'bg.neutral',
  boxShadow: '0px 2px 4px rgba(33, 29, 29, 0.2)',
});

export const dataPointContainerStyles = css.raw({
  borderRadius: '50%',
  marginTop: '50',
  border: '8px solid rgba(7, 77, 255, 0.1)',
  position: 'absolute',
  top: '1000',
});

export const dataPointStyles = css.raw({
  borderRadius: '50%',
  border: '6px solid {colors.border.onHero.neutral}',
  height: '500',
  width: '500',
  color: 'text.onHero.neutral',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'bg.accent.brand.hero',
  boxShadow: '0px 2px 4px rgba(33, 29, 29, 0.2)',
});
